import { render, staticRenderFns } from "./FiltroOrdenacao.vue?vue&type=template&id=97216678"
import script from "./FiltroOrdenacao.vue?vue&type=script&lang=js"
export * from "./FiltroOrdenacao.vue?vue&type=script&lang=js"
import style0 from "./FiltroOrdenacao.vue?vue&type=style&index=0&id=97216678&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports